module.exports = __webpack_public_path__ + "img/icon_tools.1cd2635a.svg";